import React from "react";
import "../../styles/SalesFunnel.css";
import { Link } from "react-router-dom";
import Faq from "../../Page-section/lead-generation/Faq";
import LGservice from "../../Page-section/lead-generation/LGservice";
import Portfolio from "../../components/portfolio";

import { FaLightbulb, FaUsers, FaCode, FaCogs, FaAward } from "react-icons/fa";

const LGprocess = () => {
  const points = [
    "Increased brand visibility",
    "High-quality leads",
    "Better conversion rates",
    "Improved return on investment",
    "Scalable business growth",
  ];
  const point = [
    "Targeted Lead Generation",
    "Improved Conversion Rates",
    "Increased Sales Opportunities",
    "Better ROI",
  ];

  const steps = [
    {
      id: 1,
      title: "Market Research & Audience Targeting",
      color: "green",

      icon: <FaLightbulb />,
      desc: "We identify your target audience and analyze market trends to create effective strategies.",
    },
    {
      id: 2,
      title: "Strategy Planning",
      color: "#0868a0",
      icon: <FaUsers />,
      desc: "Our crew develops custom designed plans the use of superior b2b lead generation services techniques.",
    },
    {
      id: 3,
      title: "Campaign Execution",
      color: "green",
      icon: <FaCode />,
      desc: "We put in force campaigns throughout more than one channels to draw super leads.",
    },
    {
      id: 4,
      title: "Lead Nurturing",
      color: "#0868a0",
      icon: <FaCogs />,
      desc: "We awareness on building relationships with capacity customers through personalised communication.",
    },
    {
      id: 5,
      title: "Performance Tracking",
      color: "green",
      icon: <FaAward />,
      desc: "As a expert lead generation company in india, we reveal marketing campaign performance and optimize for better consequences.",
    },
  ];
  return (
    <section className="sf-wrapper">
      <div className="sf-sidebar">
        <div className="sf-card">
          <h2>Our Services</h2>

          <ul className="sf-service-list">
              <li className="active">
              <Link to="/lead-generation-services">Lead Generation</Link>
            </li>
            <li>
              <Link to="/web-development-company-in-noida">
                Web Development
              </Link>
            </li>
            <li>
              <Link to="/web-design-services">Web Design</Link>
            </li>
            <li>
              <Link to="/seo-agency-noida">SEO Services</Link>
            </li>
              <li>
              <Link to="/social-media-marketing-services">Social Media Marketing</Link>
            </li>
            <li>
              <Link to="/content-marketing-services">Content Marketing</Link>
            </li>
            <li>
              <Link to="/ai-automation-services">AI Automation Services</Link>
            </li>

          
            <li>
              <Link to="/sales-funnel-optimization">
                Sales Funnel Optimization
              </Link>
            </li>
            <li>
              <Link to="/branding-agency-noida">Branding Services</Link>
            </li>
            <li>
              <Link to="/business-automation-services">
                Business Automation
              </Link>
            </li>
            <li>
              <Link to="/resources">Resources</Link>
            </li>
          </ul>
        </div>

        <div className="sf-card">
          <h2>Contact Info</h2>

          <div className="sf-contact">
            <p>Address :- Sector-62, Noida, India</p>
            <p>
              Phone :- <br />
              <a href="tel:+918368327503"> +91 8368327503</a> |{" "}
              <a href="tel:+919319563429"> +91 9319563429</a>
            </p>
            <p>
              Email :- <br />
              <a href="mailto:connect@empowerweb.in">connect@empowerweb.in</a>
            </p>
          </div>
        </div>
                <Portfolio />

      </div>
      <div className="sf-main-content">
        <section className="why-container">
          <div className="why-content">
            <h2>Why Lead Generation is Important for Your Business</h2>

            <p>
              Lead generation isn't pretty much collecting contact information;
              it’s about attracting ability clients who're surely interested in
              your services or products. With the assist of reliable{" "}
              <b>b2b lead generation services</b>, businesses can hook up with
              choice-makers and enhance their sales pipeline.Here are some key
              blessings of investing in lead technology offerings:
            </p>

            <ul>
              {points.map((item, index) => (
                <li key={index}>
                  <span className="check">✔</span> {item}
                </li>
              ))}
            </ul>

            <p>
              By selecting the proper <b>lead generation company in india</b>,
              you could ensure that your advertising efforts deliver actual
              consequences.
            </p>
          </div>
        </section>
        <section className="freight-container">
          <div className="freight-content">
            <h3>Why Choose Us for Lead Generation?</h3>
            <p>
              There are many <b>lead generation companies in noida</b>, however
              selecting the right accomplice is critical for achievement. Here’s
              why businesses trust us:
            </p>
            <div className="freight-boxes">
              <div className="box">
                <div>
                  <h4>B2B Lead Generation</h4>
                  <br />
                </div>
              </div>
              <div className="box">
                <div>
                  <h4>Email Marketing Campaigns</h4>
                </div>
              </div>
              <div className="box">
                <div>
                  <h4>Social Media Lead Generation</h4>
                </div>
              </div>
            </div>
            <div className="freight-boxes">
              <div className="box">
                <div>
                  <h4>PPC Lead Generation</h4>
                  <br />
                </div>
              </div>
              <div className="box">
                <div>
                  <h4>Landing Page Optimization</h4>
                </div>
              </div>
            </div>
            <br />
            <p>
              As a trusted <b>lead generation company in india</b>, we make
              certain that every campaign is optimized for optimum performance.
            </p>
          </div>
        </section>
        <LGservice />
        <section className="work-process-section">
          <h3 className="work-title">Our Lead Generation Process</h3>
          <p className="work-subtitle">
            We follow a structured and data-driven process to deliver the best{" "}
            <b>lead generation services</b>:
          </p>

          <div className="process-wrapper">
            {/* STEP LABELS */}
            <div className="process-line">
              {steps.map((step) => (
                <div
                  key={step.id}
                  className="process-step"
                  style={{ backgroundColor: step.color }}
                >
                  {step.title}
                </div>
              ))}
            </div>

            {/* STEP DETAILS */}
            <div className="process-grid">
              {steps.map((step) => (
                <div className="process-item" key={step.id}>
                  <div
                    className="process-iconv"
                    style={{ borderColor: step.color, color: step.color }}
                  >
                    {step.icon}
                  </div>
                  <h3 className="process-num" style={{ color: step.color }}>
                    {step.id.toString().padStart(2, "0")}
                  </h3>
                  <p className="process-text">{step.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="why-container">
          <div className="why-content">
            <h2>How We Help Your Business Grow</h2>

            <p>
              Our <b>lead generation services</b> are designed to deliver
              measurable outcomes and long-time period growth. Here’s how we
              make a difference:
            </p>

            <ul>
              {point.map((item, index) => (
                <li key={index}>
                  <span className="check">✔</span> {item}
                </li>
              ))}
            </ul>
          </div>
        </section>
        <section className="benefits-section">
          <div className="container">
            <div className="header">
              <div className="title-row">
                <h3>Industries We Serve</h3>

                <p>
                  As one of the trusted{" "}
                  <b>lead generation companies in noida</b>, we offer services
                  across multiple industries:
                </p>
              </div>
            </div>

            <div className="cards">
              <div className="card">
                <h3>IT & Software</h3>
              </div>
              <div className="card">
                <h3>Real Estate</h3>
              </div>
              <div className="card">
                <h3>Healthcare</h3>
              </div>
              <div className="card">
                <h3>E-trade</h3>
              </div>
              <div className="card">
                <h3>Education</h3>
              </div>{" "}
              <div className="card">
                <h3>Education</h3>
              </div>
              <div className="card">
                <h3>Finance</h3>
              </div>
            </div>
          </div>
        </section>
        <Faq />
        <section className="operations-wrapper">
          <div className="operations-left">
            <h3>Get Started Today</h3>
          </div>
          <div className="operations-right">
              <p>
                If you are looking to grow your commercial enterprise and
                generate top notch leads, it’s time to accomplice with one of
                the first-class <b>lead generation companies in noida</b>. Our
                professional crew is ready that will help you attain your
                commercial enterprise goals with established strategies and
                measurable results.
              </p>
          </div>
        </section>
      </div>
    </section>
  );
};

export default LGprocess;
